import type { AssignmentDetailFragment } from "api/generated";

export const isSingleAbilityScore = (assignment: AssignmentDetailFragment | undefined | null) =>
  assignment?.scoring?.selfEvaluation?.selfEvaluation?.trim() === "společné na celou úlohu";

export const isSelfEvaluationForEveryAssignment = (assignment: AssignmentDetailFragment | undefined) =>
  assignment?.scoring?.selfEvaluation?.selfEvaluation === "vybrané konkrétní podotázky (0-n)";
